<template>
  <div class="battery-swap-mgmt">
    <div class="main-title">
      <p v-if="view=='list'" @click="cancelHandle">{{ $t('lang.Swapping Station Management') }}</p>
      <p v-if="view=='detail'" @click="cancelHandle">{{ $t('lang.Swapping Station Management') }}</p>
      <p v-if="view=='detail'">>{{ $t('lang.Details') }}</p>
      <p v-if="view=='edit'" @click="cancelHandle">{{ $t('lang.Swapping Station Management') }}</p>
      <p v-if="view=='edit'">>{{ $t('lang.Edit') }}</p>
      <p v-if="view=='add'" @click="cancelHandle">{{ $t('lang.Swapping Station Management') }}</p>
      <p v-if="view=='add'">>{{ $t('lang.new') }}</p>
    </div>
    <div class="main-body" v-if="view=='list'">
      <el-form
        :inline="true"
        :model="form"
        class="demo-form-inline"
      >
        <el-form-item :label="$t('lang.Device ID')">
          <el-input clearable maxlength="50" class="list-input"
                    v-model="form.searchCondition" :placeholder="$t('lang.Please-enter-the-device-number')"/>
        </el-form-item>
        <el-form-item :label="$t('lang.Equipment name')">
          <el-input clearable maxlength="50" class="list-input"
                    v-model="form.deviceName" :placeholder="$t('lang.Please-enter-the-device-name')"/>
        </el-form-item>
        <el-form-item :label="$t('lang.Agent/Store')">
          <query-unit-tree @change="handleChange"/>
        </el-form-item>
        <el-form-item :label="$t('lang.Service status')">
          <el-select v-model="form.serviceStatus" class="fixed-width-200"
                     :placeholder="$t('lang.Please choose')" clearable>
            <el-option
              v-for="item in SERVICE_STATUS"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.Equipment status')">
          <el-select v-model="form.status" class="fixed-width-200"
                     :placeholder="$t('lang.Please choose')" clearable>
            <el-option
              v-for="item in onlineStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onQueryBtnClick">{{ $t('lang.Inquire') }}</el-button>
          <el-button type="primary" @click="distributionHandle">{{ $t('lang.Distribution') }}</el-button>
          <el-button type="primary" @click="confirmDownloadBtnClick">{{ $t('lang.Export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-radio-group v-model="showType" @change="shopTypeChange">
            <el-radio-button label="list">
              <div style="padding: 0 20px">list</div>
            </el-radio-button>
            <el-radio-button label="view">
              <div style="padding: 0 20px">view</div>
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="device-area" v-if="showType==='view'">
        <div class="device-item" v-for="item in recordList" :key="item.primaryDeviceNo">
          <div class="info-box">
            <div class="info-title">
              <div>{{ $t('lang.Communication board number') }}:{{item.deviceId}}</div>
              <el-button type="primary" size="mini" @click="onDetailBtnClick(item)">{{ $t('lang.Details') }}</el-button>
            </div>
            <div class="info-content">{{ $t("lang.Equipment name") }}: {{item.deviceName}}</div>
            <div class="info-content">{{ $t('lang.Location address') }}: {{item.location}}</div>
          </div>
          <div class="detail-box">
            <div class="detail-box-item" :class="showColor(cabinetItem)" v-for="(cabinetItem, cabinetIndex) in showChargePortList(item)" :key="cabinetIndex">
              <div class="class-index">{{cabinetItem.seqNo}}</div>
              <div class="first-line">
                {{statusList[cabinetItem.status]}}
              </div>
              <div class="second-line" v-if="cabinetItem.soc">
                {{cabinetItem.soc}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-table
        v-if="showType === 'list'"
        @selection-change="handleSelectionChange"
        :data="recordList"
        style="width: 100%;margin-bottom: 20px;"
        class="table-custom"
      >
        <!-- :tree-props="{ children: 'subMenuList', hasChildren: 'true' }" -->
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="primaryDeviceNo" :label="$t('lang.Device ID')" width="200"></el-table-column>
        <el-table-column prop="communicationBoardNo" :label="$t('lang.Communication board number')"
                         width="200"></el-table-column>
        <el-table-column :label="$t('lang.Equipment type')" width="200">
          <template slot-scope="{row}">
            {{ $t("lang." + $changeObj(device_Info_type)[row.typeCode]) }}
          </template>
        </el-table-column>
        <el-table-column prop="deviceName" :label="$t('lang.Equipment name')" width="200"></el-table-column>
        <el-table-column prop="showPlacingPosition" :label="$t('lang.Location address')" width="300"></el-table-column>
        <el-table-column :label="$t('lang.Agent')" width="150">
          <template slot-scope="{row}" v-if="row.agentShop && row.agentShop.agentName">
            <span>{{ row.agentShop.agentName }}</span>
            <span v-if="row.agentShop.shopName">/{{ row.agentShop.shopName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="primaryDeviceChargeStatusCode" :label="$t('lang.Device power state')" width="200">
          <template slot-scope="{row}" v-if="row.primaryDeviceChargeStatusCode">
            {{ $t('lang.' + $changeObj(primary_DeviceChargeStatusCode)[row.primaryDeviceChargeStatusCode]) }}
          </template>
        </el-table-column>
        <el-table-column prop="useElectricityDegree" :label="$t('lang.Battery used')" width="150"></el-table-column>
        <el-table-column :label="$t('lang.Number of batteries')" width="200">
          <template slot-scope="{row}">
            <p>{{ $t('lang.Number of batteries') }}：{{ row.batteryQuantity }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="enableStatus" :label="$t('lang.Device Status')" width="150">
          <template slot-scope="{row}">
            {{ $t('lang.' + $changeObj(SERVICE_STATUS)[row.enableStatus]) }}
          </template>
        </el-table-column>
        <el-table-column prop="enableStatus" :label="$t('lang.Equipment status')" width="150">
          <template slot-scope="{row}">
            {{ getStatus(row) }}
          </template>
        </el-table-column>
        <el-table-column width="200" fixed="right">
          <template slot-scope="{row}">
            <!-- <el-button @click="handleAdd(4,row)" type="primary" size="mini">分配</el-button> -->
            <!-- <el-button type="primary" size="mini" @click="onEditBtnClick(row)">分配</el-button> -->
            <el-button type="primary" size="mini" @click="onEditBtnClick(row)">{{ $t('lang.Edit') }}</el-button>
            <el-button type="primary" size="mini" @click="onDetailBtnClick(row)">{{ $t('lang.Details') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="dfcc">
        <el-pagination
          :current-page="form.beginIndex + 1"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10,20, 30, 40,50]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <div class="main-body" v-if="view == 'edit'">
      <battery-swap-mgmt-edit-view
        :editData="editData"
        @editSuccess="editSuccessHandle"
        @cancel="cancelHandle"
      ></battery-swap-mgmt-edit-view>
    </div>
    <div class="main-body" v-if="view == 'detail'">
      <battery-swap-mgmt-detail-view :editData="editData" @cancel="cancelHandle"></battery-swap-mgmt-detail-view>
    </div>
    <div class="main-body" v-if="view == 'add'">
      <charge-cabinet-mgmt-add-view
        @addSuccess="addSuccessHandle"
        @cancel="cancelHandle"
        :deviceType="2"
      ></charge-cabinet-mgmt-add-view>
    </div>
    <el-dialog width="30%" :title="$t('lang.Assign the change cabinet')" :visible.sync="distributionDialog">
      <p class="mb20">{{ $t('lang.Please select an assignment object') }}</p>
      <query-unit-tree @change="handleChangeDialog"/>
      <div class="dfe">
        <el-button type="primary" @click="distributionBtn">{{ $t('lang.Confirm') }}</el-button>
      </div>
    </el-dialog>
    <!--  -->
    <el-dialog width="30%" :title="$t('lang.Select time range')" :visible.sync="dialogVisible">
      <el-form>
        <!-- <el-form-item label="开始时间">
          <el-date-picker
            v-model="exportTime.beginTime"
            class="date-global"
            size="mini"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="timestamp"
            placeholder="选择开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            v-model="exportTime.endTime"
            size="mini"
            class="date-global"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="timestamp"
            placeholder="选择结束时间">
          </el-date-picker>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('lang.Cancel') }}</el-button>
        <el-button type="primary">{{ $t('lang.Confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {SERVICE_STATUS, primary_DeviceChargeStatusCode, device_Info_type} from '@/utils/constant';
import {deviceList, distributeDevice} from '@/api/deviceManagement';
import BatterySwapMgmtEditView from "./batterySwapMgmtEditView";
import BatterySwapMgmtDetailView from "./batterySwapMgmtDetailView";
import ChargeCabinetMgmtAddView from "./chargeCabinetMgmtAddView";
import queryUnitTree from '@/components/common/queryUnitTree';
import {exportExcel} from "../../api/export";

export default {
  name: "batterySwapMgmt",
  components: {
    BatterySwapMgmtDetailView,
    BatterySwapMgmtEditView,
    ChargeCabinetMgmtAddView,
    queryUnitTree
  },
  data() {
    return {
      //是否正在导出的标志
      isExportFlag: false,
      device_Info_type,
      primary_DeviceChargeStatusCode,
      timeArr: [],
      SERVICE_STATUS,
      onlineStatusList: [
        {
          value: '',
          label: this.$t('lang.All')
        },
        {
          value: '100',
          label: this.$t('lang.Online')
        },
        {
          value: '-1',
          label: this.$t('lang.Offline')
        },
      ],
      form: {
        status: '',
        searchCondition: '',
        deviceName: '',
        deviceType: 2,
        unitNo: '',
        serviceStatus: '',
        beginIndex: 0,
        pageSize: 10,
        exportType:33
      },
      recordList: [],
      serviceDistribution: '',//选择分配对象
      distributionDialog: false,

      multipleSelection: [],
      view: "list",
      unitNo: [],
      unitNo2: [],
      unitList: [],
      total: 0,
      dataList: [],
      editData: {},
      dialogVisible: false,
      showType: 'list',
      statusList: {
        '1': 'Empty',
        '2': 'Fully Charged',
        '3': 'Charging',
        '4': 'Empty',
        '5': 'Empty'
      }
    };
  },
  mounted() {
    if (this.$route.query.searchCondition) {
      this.searchCondition = this.$route.query.searchCondition;
    }
    if (this.$route.query.deviceName) {
      this.deviceName = this.$route.query.deviceName;
    }
    if (this.$route.query.beginIndex) {
      this.beginIndex = this.$route.query.beginIndex;
    }
    if (this.$route.query.primaryDeviceNo) {
      let data = {primaryDeviceNo: this.$route.query.primaryDeviceNo};
      this.onDetailBtnClick(data);
    }
    this.deviceList();
  },
  computed: {
    canExportRecord() {
      return this.$store.state.canExportRecord;
    },
    // existingBattery(){//已有电池数量
    //   if(){
    //     recordList.batteryPropertyList
    //   }
    //   return
    // }
  },
  methods: {
    showChargePortList(item) {
      const list = JSON.parse(JSON.stringify(item.chargePortList || []))
      //行数
      const lineAmount = Math.ceil(list.length / 2)
      return list.sort((a, b) => {
        let aNo = Number(a.seqNo || 0)
        let bNo = Number(b.seqNo || 0)
        if(aNo > lineAmount) {
          aNo -=lineAmount
        }
        if(bNo > lineAmount) {
          bNo -=lineAmount
        }
        return aNo - bNo
      })
    },
    shopTypeChange() {
      this.recordList = []
      this.deviceList()
    },
    /**
     * 显示的颜色
     * @param item
     */
    showColor(item) {
      if(item.status == '2') {
        return ['green']
      }
      if(item.status == '3') {
        return ['orange']
      }
      if(item.status == '4') {
        return ['gray']
      }
      if(item.status == '1') {
        return ['deep-gray']
      }
      return ['gray']
    },
    getStatus(item) {
      if(!item || !item.status) {
        return ''
      }
      const findResult = this.onlineStatusList.find((el) => {
        return el.value == item.status
      })
      if(findResult) {
        return findResult.label
      }
      return ''
    },
    //导出
    confirmDownloadBtnClick() {
      let self = this;
      this.$confirm(this.$t('lang.Whether to confirm export'), "", {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.Cancel'),
        type: "warning"
      })
        .then(() => {
          self.downloadBtnClick();
        })
        .catch(action => {
        });
    },
    //导出
    async downloadBtnClick() {
      if (this.isExportFlag) {
        this.$message.warning(this.$t('lang.Being exported') + '...')
        return
      }
      let self = this;
      let params = {
        ...this.form
      };
      if (this.unitNo && this.unitNo.length > 0) {
        params.unitNo = this.unitNo[this.unitNo.length - 1];
      } else {
        params.unitNo = null;
      }
      try {
        this.isExportFlag = true
        await exportExcel(params)
        this.isExportFlag = false
        this.$message.success(this.$t('lang.Export successful'))
        setTimeout(function () {
          self.$router.push('/managePage/downloadTask')
        }, 1000)
      } catch (e) {
        this.isExportFlag = false
      }
    },
    // 分配弹窗选组织
    handleChangeDialog(val) {
      this.unitNo2 = val;
    },
    // select组件
    handleChange(val) {
      this.unitNo = val;
    },
    // 分配弹窗
    distributionHandle() {
      if (this.multipleSelection && this.multipleSelection.length === 0) {
        this.$message.warning(this.$t('lang.Please select equipmente'));
        return;
      }
      this.serviceDistribution = '';//清空分配下拉
      this.distributionDialog = true;
    },
    // 分配确认按钮
    async distributionBtn() {
      const params = {
        deviceNoList: JSON.stringify(this.multipleSelection)
      };
      if (this.unitNo2 && this.unitNo2.length > 0) {
        params.unitNo = this.unitNo2[this.unitNo2.length - 1];
      } else {
        params.unitNo = null;
      }
      const res = await distributeDevice(params);
      if (res.result === 1) {
        this.$message.success(this.$t('lang.Successful'));
      }
      this.distributionDialog = false;
    },
    // 选项改变
    handleSelectionChange(arr) {
      if (arr.length === 0) {
        this.multipleSelection = [];
        return;
      }
      arr.forEach(el => {
        this.multipleSelection.push(el.primaryDeviceNo);
      });
    },
    handleCurrentChange(page) {
      this.form.beginIndex = page - 1;
      this.deviceList();
    },
    handleSizeChange(pageSize) {
      this.form.pageSize = pageSize;
    },
    // 发送请求list获取数据
    async deviceList() {
      const params = {
        ...this.form,
      };
      if(this.showType === 'view') {
        params.flag = '1'
      }
      if (this.unitNo && this.unitNo.length > 0) {
        params.unitNo = this.unitNo[this.unitNo.length - 1];
      } else {
        params.unitNo = null;
      }
      try {
        const res = await deviceList(params);
        this.total = res.mdata.total;
        this.recordList = res.ldata;
      } catch (e) {
        console.log(e);
      }
    },
    // 查询按钮
    onQueryBtnClick() {
      this.form.beginIndex = 0;
      this.deviceList();
    },

    onEditBtnClick(data) {
      this.view = "edit";
      this.$nextTick(() => {
        this.editData = data;
      });
    },
    // 查看详情
    onDetailBtnClick(row) {
      this.view = "detail";
      this.$nextTick(() => {
        let searchCondition = {
          searchCondition: this.form.searchCondition,
          deviceName: this.form.deviceName,
          beginIndex: this.form.beginIndex
        };
        if(this.showType === 'view') {
          row.primaryDeviceNo = row.deviceNo
        }
        this.editData = row;
        this.editData.searchCondition = searchCondition;
      });
    },
    editSuccessHandle() {
      this.view = "list";
      this.deviceList();
    },
    cancelHandle() {
      this.view = "list";
      this.deviceList();
    },
    addSuccessHandle() {
      this.view = "list";
      this.deviceList();
    },

    downloadRecordBtnClick() {
      this.dialogVisible = true;
    },

  }
};
</script>

<style lang="scss" scoped>
.main-body {
  .list {
    line-height: 30px;
    margin: 20px 30px 10px;

    .name-label {
      float: left;
    }

    .value-label {
      display: inline-block;
      height: 30px;
    }

    .date-global {
      width: 185px;
    }

    .list-input {
      width: 180px;
    }
  }

  .table-custom {
    .text-btn {
      width: 50px;
      height: 24px;
      line-height: 24px;
      color: #417505;
      display: inline-block;
      background-color: #bee6b3;
      cursor: pointer;
    }

    .fixed-width-75 {
      width: 75px;
    }
  }
  .device-area {
    display: flex;
    flex-wrap: wrap;
    .device-item {
      flex-basis: 18%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 10px;
      margin: 10px;
      border-radius: 20px;
      background: #FFFFFF;
      box-shadow: 0 4px 6px 0 #e2e2e2;
      .info-box {
        .info-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 5px 0;
          font-size: 16px;
          font-weight: bold;
        }
        .info-content {
          padding: 5px 0;
          font-size: 14px;
        }
      }
      .detail-box {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        .detail-box-item {
          position: relative;
          flex-basis: 45%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-around;
          box-sizing: border-box;
          height: 50px;
          padding: 10px 0 10px 20px;
          margin: 5px;
          border-radius: 10px;
          .class-index {
            position: absolute;
            width: 20px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            top: 5px;
            left: 5px;
            border-radius: 5px;
            background: #FFFFFF;
            color: #333333;
          }
        }
      }
    }
    .orange{
      background:#FD8F02;
      color: #FFFFFF;
    }
    .deep-gray{
      background:#E0E0E0;
      color: #999999;
    }
    .green{
      background:#39B54A;
      color: #FFFFFF;
    }
    .gray{
      background:#E0E0E0;
      color: #bbbbbb;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/batterySwapMgmt.vue